import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

const Footer = () => (
  <footer className="bg-foreground text-background">
    <div className="container py-12 sm:py-16">
      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="flex h-9 w-9 items-center justify-center rounded-md bg-accent font-display text-sm font-bold text-accent-foreground">
              M
            </div>
            <span className="font-display text-lg font-bold">MMA Group Qatar</span>
          </div>
          <p className="text-sm text-background/60 leading-relaxed">
            Leading supplier of water pumps, pressure tanks, generators, and industrial equipment in Qatar since 1977.
          </p>
        </div>
        <div>
          <h3 className="font-display text-sm font-semibold mb-4">Quick Links</h3>
          <nav className="flex flex-col gap-2">
            {[{ to: "/shop", label: "Shop" }, { to: "/about", label: "About Us" }, { to: "/contact", label: "Contact" }].map(
              (link) => (
                <Link key={link.to} to={link.to} className="text-sm text-background/60 hover:text-accent transition-colors">
                  {link.label}
                </Link>
              )
            )}
          </nav>
        </div>
        <div>
          <h3 className="font-display text-sm font-semibold mb-4">Categories</h3>
          <nav className="flex flex-col gap-2">
            {["Water Pumps", "Pressure Tanks", "Generators", "Incubators"].map((cat) => (
              <Link key={cat} to="/shop" className="text-sm text-background/60 hover:text-accent transition-colors">
                {cat}
              </Link>
            ))}
          </nav>
        </div>
        <div>
          <h3 className="font-display text-sm font-semibold mb-4">Contact</h3>
          <div className="flex flex-col gap-3 text-sm text-background/60">
            <div className="flex items-center gap-2"><Phone className="h-4 w-4 text-accent shrink-0" /> +974 7066 6513</div>
            <div className="flex items-center gap-2"><Mail className="h-4 w-4 text-accent shrink-0" /> info@mmagroupqatar.com</div>
            <div className="flex items-start gap-2"><MapPin className="h-4 w-4 text-accent mt-0.5 shrink-0" /> Industrial Area, Doha, Qatar</div>
          </div>
        </div>
      </div>
    </div>
    <div className="border-t border-background/10">
      <div className="container py-4 text-center text-xs text-background/60">
        © {new Date().getFullYear()} MMA Group Qatar. All rights reserved.
      </div>
    </div>
  </footer>
);

export default Footer;
